import React from 'react';

const NoData = () => <div className="no-data">No Data</div>;

export default NoData;
